export default "__VITE_ASSET__BaPBlIJQ__"